<template>
  <el-row justify="center" align="middle" class="rosegrid">
    <div :class="dollar==1?'rg_content_big':'rg_content'">
      <span v-if="dollar==1" class="dollar">$</span> {{ data.title }}
    </div>
    <div :class="dollar==1?'rg_desc_big':'rg_desc'">
      {{ data.content }}
    </div>
  </el-row>
</template>

<script>
export default {
  name: "RoseGrid",
  components: {},
  props: {
    data:Object,
    dollar:Number
  },

};
</script>

<style>
.rosegrid {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.rg_content {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
}
.rg_desc {
  width: 100%;
  font-size: 8px;
  color: #999999;
}
.rg_content_big {
  width: 100%;
  font-size: 20px;
  font-weight: 500;
}
.rg_desc_big {
  width: 100%;
  font-size: 10px;
  color: #999999;
}
.dollar {
  font-size: 22px;
  color: #d90514;
}
</style>
